<template>
  <div class="hr">
    <div class="header">
      <p>Melde dich gerne für weitere Infos bei:</p>
    </div>
    <div class="people">
      <div class="person">
        <div class>
          <p>Mara Schulte-Schröer</p>
          <p>Head of HR</p>
        </div>
        <img src="../../images/mara_pixelart2.png" />
        <p>schulte-schroeer@gonicus.de</p>
      </div>
      <div class="person">
        <p>Heike Ahlmer</p>
        <p>HR Managerin</p>
        <img src="../../images/heike_pixelart2.png" />
        <p>ahlmer@gonicus.de</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ResultHRM",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.header {
  grid-area: header;
  text-align: left;
}
p {
  color: #0f0f;
}
img {
  position: relative;
  width: 30%;
  justify-content: left;
}
.people {
  grid-area: content;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.person {
  text-align: left;
}
.hr {
  /**   display: block;
  justify-content: center;*/
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "header" "content";
}
</style>